<template>
  <div
    class="hold-transition home-view"
    :class="{ 'home-view--dark': $store.getters.getDarkMode }"
  >
    <loading v-if="cargando" />
    <div class="wrapper">
      <div class="content-wrapper home-content-wrapper">
        <div class="content-header home-content-header">
          <div class="container-fluid">
            <div class="row mb-3 mb-md-4">
              <div class="col-12">
                <div
                  class="alert alert-default-warning col-md-12 text-center p-4"
                  v-if="showAlert && this.$store.state.user.status !== 1"
                >
                  <h1 style="font-size: 1.7rem">
                    <i class="icon fas fa-exclamation-triangle"></i>
                    Por favor comunicarse con un administrador de Support 7-24.
                  </h1>
                </div>
                <div
                  v-if="mostrarAvisoSinPermisosModulo"
                  class="alert alert-warning col-md-10 col-lg-8 mx-auto text-center shadow-sm"
                  role="alert"
                >
                  <h2 class="h5 mb-2 font-weight-bold">
                    <i class="fas fa-user-lock mr-2"></i>Sin permisos para este
                    módulo
                  </h2>
                  <p class="mb-0">
                    Tiene cliente y línea de negocio asignados, pero no tiene
                    rol o permisos que permitan ingresar. Comuníquese con el
                    administrador de su organización o de Support7-24 para que
                    le asignen el perfil correspondiente.
                  </p>
                </div>
                <div class="home-welcome-block">
                  <h1 class="home-welcome m-0">
                    Bienvenido, {{ this.$store.state.user.name }}
                  </h1>
                  <p class="home-welcome-sub">
                    Selecciona un cliente o módulo para continuar
                  </p>
                  <div class="home-welcome-line"></div>
                </div>
              </div>
            </div>
            <!-- Main content: mostrar paneles cuando hay usuario (v-show para que el bloque exista en DOM y no quede pantalla en blanco) -->
            <section
              class="content home-section"
              v-show="!!(this.$store.state.user || this.$store.state.auth)"
            >
              <div class="container-fluid">
                <!-- Respaldo: si por algún motivo no se muestra ningún panel, ofrecer volver -->
                <div
                  v-if="
                    usuarioTieneVariosClientesAsignados &&
                    !mostrarSeleccionCliente &&
                    !mostrarMenuModulos
                  "
                  class="alert alert-info"
                >
                  <button
                    type="button"
                    class="btn btn-sm btn-primary"
                    @click="cambiarCliente"
                  >
                    <i class="fa fa-arrow-left mr-1"></i> Volver a selección de
                    cliente
                  </button>
                </div>
                <!-- Paso 1: Selección de cliente plataforma -->
                <div
                  class="card home-panel shadow home-panel-clientes"
                  v-if="mostrarSeleccionCliente"
                  key="panel-clientes"
                >
                  <div class="card-header home-panel-header">
                    <span class="home-panel-header-accent"></span>
                    <i class="fa fa-building mr-2"></i>
                    <span>Selecciona un cliente para continuar</span>
                  </div>
                  <div class="card-body home-panel-body">
                    <p
                      v-if="!clientesParaMostrar.length"
                      class="text-muted text-center mb-0"
                    >
                      No hay clientes disponibles para mostrar. Contacta al
                      administrador si debes tener acceso.
                    </p>
                    <div
                      class="row justify-content-center"
                      v-else
                    >
                      <div
                        class="col-12 col-sm-6 col-md-4 col-lg-3 mb-4"
                        v-for="cliente in clientesParaMostrar"
                        :key="cliente.id"
                      >
                        <div
                          class="card card-widget widget-user home-module-card h-100"
                        >
                          <div
                            class="widget-user-header text-white bg-support-blue-gradient"
                          >
                            <span class="home-card-badge">Support 7-24</span>
                            <h5 class="widget-user-desc">
                              {{ nombreCliente(cliente) }}
                            </h5>
                          </div>
                          <div class="card-footer pt-3 pb-3">
                            <button
                              @click="seleccionarCliente(cliente.id)"
                              class="btn btn-block home-btn-vermas"
                            >
                              <i class="fa fa-arrow-right mr-2"></i> Acceder
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Paso 2: Si el cliente tiene varias líneas (ej. Sos Contingencias) se muestra para elegir; si solo tiene una se redirige al menú directo -->
                <div
                  class="card home-panel shadow home-panel-modulos"
                  v-if="mostrarPanelLineasNegocio"
                  key="panel-modulos"
                >
                  <div
                    class="card-header home-panel-header d-flex justify-content-between align-items-center flex-wrap"
                  >
                    <span class="home-panel-header-accent"></span>
                    <span>
                      <i class="fa fa-th-large mr-2"></i>
                      <template v-if="lineasParaMostrarEnPanel.length > 1">
                        Elige una línea de negocio para continuar
                      </template>
                      <template
                        v-else-if="lineasParaMostrarEnPanel.length === 1"
                      >
                        Módulo disponible para el cliente actual
                      </template>
                      <template v-else>
                        Selecciona un módulo para iniciar
                      </template>
                    </span>
                    <button
                      v-if="usuarioTieneVariosClientesAsignados"
                      type="button"
                      class="btn btn-sm home-btn-back mt-2 mt-md-0"
                      @click="cambiarCliente"
                    >
                      <i class="fa fa-exchange-alt mr-1"></i> Cambiar de cliente
                    </button>
                  </div>
                  <div class="card-body home-panel-body">
                    <p
                      v-if="lineasParaMostrarEnPanel.length > 1"
                      class="text-muted text-center mb-3 small"
                    >
                      Este cliente tiene más de una línea de negocio. Selecciona
                      la que deseas usar.
                    </p>
                    <p
                      v-else-if="lineasParaMostrarEnPanel.length === 0"
                      class="text-muted text-center mb-0"
                    >
                      No hay líneas de negocio asignadas para este cliente.
                      Contacta al administrador.
                    </p>
                    <div
                      class="row justify-content-center"
                      v-if="lineasParaMostrarEnPanel.length > 0"
                    >
                      <div
                        class="col-12 col-sm-6 col-md-4 col-lg-3 mb-4"
                        v-for="linea in lineasParaMostrarEnPanel"
                        :key="linea.id"
                      >
                        <div
                          class="card card-widget widget-user home-module-card h-100"
                        >
                          <div
                            class="widget-user-header text-white bg-support-blue-gradient"
                          >
                            <span class="home-card-badge">Support 7-24</span>
                            <h5 class="widget-user-desc">{{ linea.nombre }}</h5>
                          </div>
                          <div class="card-footer pt-3 pb-3">
                            <button
                              @click="
                                irLineaNegocio(linea.id, {
                                  fromUserClick: true,
                                })
                              "
                              class="btn btn-block home-btn-vermas"
                            >
                              <i class="fa fa-arrow-right mr-2"></i> Acceder
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
      <ContentWrapper v-show="this.$store.state.auth" />
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeView",
};
</script>

<script>
import ContentWrapper from "./../components/layout/ContentWrapper";
import Loading from "./../components/LoadingSpinner";
import axios from "axios";
export default {
  name: "HomeView",
  components: {
    ContentWrapper,
    Loading,
  },
  data() {
    return {
      cargando: false,
      showAlert: false,
      todosLosClientes: [], // cuando el usuario no tiene clientes asignados, se cargan todos
      yaIntentadoRedirigirUnModulo: false, // evita bucle si la redirección automática falla
      clienteSeleccionadoId: null, // estado local para que la vista cambie al instante al hacer clic en Acceder
    };
  },

  computed: {
    clientesPlataformaDelUsuario() {
      const user = this.$store.state.user;
      return user?.clientes_plataforma ?? user?.clientesPlataforma ?? [];
    },
    clientesParaMostrar() {
      const asignados = this.clientesPlataformaDelUsuario;
      if (asignados.length > 0) return asignados;
      return this.todosLosClientes;
    },
    lineasDelUsuario() {
      const user = this.$store.state.user;
      return user?.lineas_negocio ?? user?.lineasNegocio ?? [];
    },
    lineasFiltradasPorCliente() {
      const lineas = this.lineasDelUsuario;
      const clienteId = this.$store.getters.getCurrentClientePlataformaId;
      if (!clienteId) return lineas;
      return lineas.filter((l) => {
        const id = l.cliente_plataforma_id ?? l.clientePlataformaId;
        return id != null && Number(id) === Number(clienteId);
      });
    },
    /** Líneas a mostrar en el panel: desde el store (se actualiza al recibir API) o fallback del user */
    lineasParaMostrarEnPanel() {
      const desdeStore = this.$store.getters.getLineasParaClienteActual || [];
      if (desdeStore.length > 0) return desdeStore;
      return this.lineasFiltradasPorCliente;
    },
    mostrarSeleccionCliente() {
      // Usar estado local para que la vista cambie al instante al hacer clic (el store a veces no actualiza la vista a tiempo)
      if (this.clienteSeleccionadoId) return false;
      const noHayClienteSeleccionado =
        !this.$store.getters.getCurrentClientePlataformaId;
      const sinClientesAsignados =
        this.clientesPlataformaDelUsuario.length === 0;
      if (sinClientesAsignados) return true;
      return noHayClienteSeleccionado;
    },
    mostrarMenuModulos() {
      const tieneClienteLocal = !!this.clienteSeleccionadoId;
      const tieneClienteEnStore =
        !!this.$store.getters.getCurrentClientePlataformaId;
      return tieneClienteLocal || tieneClienteEnStore;
    },
    mostrarAvisoSinPermisosModulo() {
      const f = this.$store.state.entradaModuloFallida;
      if (!f) return false;
      const cid = this.$store.getters.getCurrentClientePlataformaId;
      if (cid == null || Number(f.clientePlataformaId) !== Number(cid))
        return false;
      const lineas = this.lineasParaMostrarEnPanel;
      if (!lineas.length) return true;
      return lineas.some((l) => Number(l.id) === Number(f.lineaNegocioId));
    },
    /** Solo usuarios con más de un cliente plataforma asignado pueden cambiar de cliente. */
    usuarioTieneVariosClientesAsignados() {
      return this.clientesPlataformaDelUsuario.length > 1;
    },
    /**
     * Muestra el panel de líneas con el cliente ya elegido (p. ej. al volver con Inicio).
     * Con una sola línea se oculta solo mientras corre la redirección automática (cargando).
     */
    mostrarPanelLineasNegocio() {
      if (!this.mostrarMenuModulos) return false;
      const n = this.lineasParaMostrarEnPanel.length;
      if (n === 0) return true;
      if (n > 1) return true;
      return !this.cargando || this.yaIntentadoRedirigirUnModulo;
    },
  },

  watch: {
    "$store.state.homeClienteSeleccionResetNonce"() {
      this.clienteSeleccionadoId = null;
      this.yaIntentadoRedirigirUnModulo = false;
    },
    "$store.state.user.status": {
      immediate: true,
      handler(newStatus) {
        if (newStatus !== 1) {
          this.showAlert = true;
          setTimeout(() => {
            this.$store.dispatch("logout");
            this.$router.push("/login");
          }, 5000);
        }
      },
    },
    // Si solo hay un módulo para el cliente seleccionado, ir directo sin mostrar selección
    lineasFiltradasPorCliente: {
      handler(lineas) {
        if (
          !this.$store.state.user ||
          this.$store.state.user.status !== 1 ||
          this.cargando ||
          this.yaIntentadoRedirigirUnModulo
        )
          return;
        if (!this.$store.getters.getCurrentClientePlataformaId) return;
        if (lineas.length === 1) {
          if (this.debeBloquearAutoEntradaModulo(lineas[0].id)) {
            this.yaIntentadoRedirigirUnModulo = true;
            return;
          }
          this.yaIntentadoRedirigirUnModulo = true;
          this.irLineaNegocio(lineas[0].id);
        }
      },
      immediate: true,
    },
  },

  methods: {
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },

    nombreCliente(cliente) {
      return cliente.nomnbre ?? cliente.nombre ?? "Cliente";
    },
    async seleccionarCliente(clientePlataformaId) {
      this.cargando = true;
      this.$store.commit("SET_LINEAS_PARA_CLIENTE_ACTUAL", []);
      this.clienteSeleccionadoId = clientePlataformaId;
      this.$store.commit(
        "SET_CURRENT_CLIENTE_PLATAFORMA_ID",
        clientePlataformaId,
      );
      await this.$nextTick();
      try {
        const res = await axios.get("/api/lineas-negocio", {
          params: { cliente_plataforma_id: clientePlataformaId },
        });
        const lineas = Array.isArray(res.data) ? res.data : [];
        if (lineas.length === 1) {
          this.yaIntentadoRedirigirUnModulo = true;
          await this.irLineaNegocio(lineas[0].id);
          return;
        }
        this.$store.commit("SET_LINEAS_PARA_CLIENTE_ACTUAL", lineas);
        this.cargando = false;
        await this.$nextTick();
      } catch (e) {
        console.error("Error al cargar líneas del cliente:", e);
        const fallback = this.lineasFiltradasPorCliente || [];
        this.$store.commit("SET_LINEAS_PARA_CLIENTE_ACTUAL", fallback);
        if (fallback.length === 1) {
          this.yaIntentadoRedirigirUnModulo = true;
          await this.irLineaNegocio(fallback[0].id);
        }
        this.cargando = false;
      } finally {
        if (this.cargando !== false) this.cargando = false;
      }
    },
    cambiarCliente() {
      this.$store.dispatch("prepararCambioDeClientePlataforma");
    },

    debeBloquearAutoEntradaModulo(lineaNegocioId) {
      const f = this.$store.state.entradaModuloFallida;
      if (!f) return false;
      const cid = this.$store.getters.getCurrentClientePlataformaId;
      if (cid == null) return false;
      return (
        Number(f.lineaNegocioId) === Number(lineaNegocioId) &&
        Number(f.clientePlataformaId) === Number(cid)
      );
    },

    marcarEntradaModuloSinAcceso(linea_negocio_id) {
      this.$store.commit("SET_ENTRADA_MODULO_FALLIDA", {
        lineaNegocioId: linea_negocio_id,
        clientePlataformaId: this.$store.getters.getCurrentClientePlataformaId,
      });
      this.yaIntentadoRedirigirUnModulo = true;
    },

    async irLineaNegocio(linea_negocio_id, opts = {}) {
      if (opts.fromUserClick) {
        this.$store.commit("CLEAR_ENTRADA_MODULO_FALLIDA");
      } else if (this.debeBloquearAutoEntradaModulo(linea_negocio_id)) {
        this.yaIntentadoRedirigirUnModulo = true;
        this.cargando = false;
        return;
      }
      this.cargando = true;
      try {
        await this.$store.dispatch("getMenus", linea_negocio_id);
        await this.$store.dispatch("getRoutes", this.$store.getters.getMenus);
        await this.$store.dispatch("setRoutes");
        const menus = this.$store.getters.getMenus || [];
        const rutas = this.$store.getters.getRoutes || [];
        const primeraRuta = rutas[0]?.path;

        if (!menus.length) {
          this.marcarEntradaModuloSinAcceso(linea_negocio_id);
          return;
        }

        const ir = async (path) => {
          this.$store.commit("CLEAR_ENTRADA_MODULO_FALLIDA");
          await this.$nextTick();
          return this.$router.replace(path);
        };

        if (linea_negocio_id == 1) {
          return ir("/Admin");
        }
        if (linea_negocio_id == 2) {
          return ir("/Logistica");
        }
        if (linea_negocio_id == 3) {
          return ir("/Emergencias");
        }
        if (linea_negocio_id == 4) {
          return ir("/Facturacion");
        }
        if (linea_negocio_id == 5) {
          return ir("/Compras");
        }
        if (linea_negocio_id == 11) {
          return ir("/Sos/Comercial/Dashboard");
        }
        // Línea 6 (Biomax/Seguridad): entrar al dashboard, no a la primera ruta del menú
        if (linea_negocio_id == 6) {
          if (!primeraRuta) this.$store.dispatch("addDefaultSeguridadRoute");
          return ir("/Biomax/Dashboard");
        }
        // Línea 7 (Trafigura): dashboard solo con permiso; si no, primera ruta del menú
        if (linea_negocio_id == 7) {
          if (this.$store.getters.can("trafigura.dashboard.index")) {
            return ir("/Trafigura/Dashboard");
          }
          if (primeraRuta) {
            return ir(primeraRuta);
          }
          this.marcarEntradaModuloSinAcceso(linea_negocio_id);
          return;
        }
        // Cualquier otra línea de negocio: ir a la primera ruta del menú cargado
        if (primeraRuta) {
          return ir(primeraRuta);
        }
        this.marcarEntradaModuloSinAcceso(linea_negocio_id);
      } catch (e) {
        console.error("Error al cargar módulo:", e);
        this.marcarEntradaModuloSinAcceso(linea_negocio_id);
      } finally {
        this.cargando = false;
      }
    },
  },

  async mounted() {
    this.toggleBodyClass("addClass", "sidebar-collapse");
    this.toggleBodyClass("removeClass", "sidebar-mini");
    const asignados = this.clientesPlataformaDelUsuario;
    if (asignados.length === 1) {
      const clienteId = asignados[0].id;
      this.clienteSeleccionadoId = clienteId;
      this.$store.commit("SET_CURRENT_CLIENTE_PLATAFORMA_ID", clienteId);
      try {
        const res = await axios.get("/api/lineas-negocio", {
          params: { cliente_plataforma_id: clienteId },
        });
        const lineas = Array.isArray(res.data) ? res.data : [];
        this.$store.commit("SET_LINEAS_PARA_CLIENTE_ACTUAL", lineas);
        if (lineas.length === 1) {
          if (this.debeBloquearAutoEntradaModulo(lineas[0].id)) {
            this.yaIntentadoRedirigirUnModulo = true;
            return;
          }
          this.yaIntentadoRedirigirUnModulo = true;
          await this.irLineaNegocio(lineas[0].id);
        }
      } catch (_) {
        this.$store.commit(
          "SET_LINEAS_PARA_CLIENTE_ACTUAL",
          this.lineasFiltradasPorCliente || [],
        );
      }
    } else if (asignados.length === 0) {
      this.$store.commit("SET_CURRENT_CLIENTE_PLATAFORMA_ID", null);
      try {
        const res = await axios.get("/api/clientes-plataforma");
        this.todosLosClientes = res.data ?? [];
      } catch (_) {
        this.todosLosClientes = [];
      }
    }

    const cidPersistido = this.$store.getters.getCurrentClientePlataformaId;
    const lineasEnStore = this.$store.getters.getLineasParaClienteActual || [];
    if (cidPersistido && lineasEnStore.length === 0) {
      try {
        const res = await axios.get("/api/lineas-negocio", {
          params: { cliente_plataforma_id: cidPersistido },
        });
        const lineas = Array.isArray(res.data) ? res.data : [];
        this.$store.commit("SET_LINEAS_PARA_CLIENTE_ACTUAL", lineas);
      } catch (_) {
        this.$store.commit(
          "SET_LINEAS_PARA_CLIENTE_ACTUAL",
          this.lineasFiltradasPorCliente || [],
        );
      }
    }
  },

  destroyed() {
    this.toggleBodyClass("removeClass", "sidebar-collapse");
    this.toggleBodyClass("addClass", "sidebar-mini");
  },
};
</script>

<style scoped>
/* Fondo de la vista Home: azul muy suave en claro, oscuro en dark + patrón sutil */
.home-view .home-content-wrapper {
  background: linear-gradient(160deg, #f0f4fa 0%, #e8eef6 50%, #f5f7fa 100%);
  min-height: calc(100vh - 57px);
  position: relative;
}
.home-view .home-content-wrapper::before {
  content: "";
  position: absolute;
  inset: 0;
  background-image: radial-gradient(
      circle at 20% 30%,
      rgba(21, 63, 117, 0.04) 0%,
      transparent 45%
    ),
    radial-gradient(
      circle at 80% 70%,
      rgba(21, 63, 117, 0.03) 0%,
      transparent 40%
    );
  pointer-events: none;
}
.home-view--dark .home-content-wrapper {
  background: linear-gradient(165deg, #0a1428 0%, #0d1835 40%, #080f1c 100%);
}
.home-view--dark .home-content-wrapper::before {
  background-image: radial-gradient(
      circle at 20% 30%,
      rgba(21, 63, 117, 0.12) 0%,
      transparent 50%
    ),
    radial-gradient(
      circle at 80% 70%,
      rgba(30, 90, 158, 0.06) 0%,
      transparent 45%
    );
}

/* Cabecera y bienvenida */
.home-content-header {
  padding-top: 2rem;
  padding-bottom: 0.5rem;
  position: relative;
  z-index: 1;
}
.home-welcome-block {
  text-align: center;
  margin-bottom: 0.5rem;
}
.home-welcome-icon {
  font-size: 1.5rem;
  color: #9bc04a;
  opacity: 0.95;
  margin-bottom: 0.5rem;
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.08));
}
.home-view--dark .home-welcome-icon {
  color: #bad35c;
  opacity: 0.95;
}
.home-welcome {
  font-size: 1.85rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: #153f75;
  margin-bottom: 0.35rem;
}
.home-welcome-sub {
  font-size: 0.95rem;
  color: #5a6c7d;
  margin: 0 0 1rem 0;
  font-weight: 400;
}
.home-welcome-line {
  width: 80px;
  height: 3px;
  background: linear-gradient(
    90deg,
    transparent,
    #9bc04a,
    #bad35c,
    transparent
  );
  margin: 0 auto;
  border-radius: 2px;
  opacity: 0.85;
}
.home-view--dark .home-welcome-line {
  background: linear-gradient(
    90deg,
    transparent,
    #bad35c,
    #9bc04a,
    transparent
  );
  opacity: 0.9;
}
.home-view--dark .home-welcome {
  color: #e4e6eb;
}
.home-view--dark .home-welcome-sub {
  color: #9ca3af;
}

/* Paneles: blanco + azul, buen contraste; evitan superposición */
.home-panel {
  border: none;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(21, 63, 117, 0.12);
  border-left: 4px solid #153f75;
}
.home-panel-clientes {
  margin-bottom: 0;
}
.home-panel-modulos {
  margin-top: 1.5rem;
}
.home-view--dark .home-panel {
  background: rgba(13, 21, 38, 0.85);
  border: 1px solid rgba(66, 113, 171, 0.25);
  border-left: 4px solid #bad35c;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.2);
}

/* Barra "Selecciona un cliente": gradiente verde+azul también en modo oscuro */
.home-panel-header {
  position: relative;
  background: linear-gradient(
    135deg,
    #9bc04a 0%,
    #7fb83a 25%,
    #153f75 55%,
    #0d2d5c 85%,
    #001871 100%
  );
  color: #fff;
  font-weight: 600;
  letter-spacing: 0.02em;
  border-bottom: none;
  padding: 1rem 1.5rem 1rem 2rem;
  font-size: 1.05rem;
}
.home-panel-header-accent {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.6),
    rgba(255, 255, 255, 0.3)
  );
  border-radius: 0 2px 2px 0;
}
.home-view--dark .home-panel-header {
  background: linear-gradient(
    135deg,
    #bad35c 0%,
    #9bc04a 22%,
    #7fb83a 40%,
    #153f75 65%,
    #0d2d5c 85%,
    #001871 100%
  ) !important;
  color: #fff;
}
.home-view--dark .home-panel-header-accent {
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.5),
    rgba(255, 255, 255, 0.2)
  );
}
.home-panel-body {
  padding: 1.5rem 1rem;
  position: relative;
  z-index: 1;
}

/* Tarjetas cliente/módulo */
.home-section >>> .home-module-card {
  min-height: 280px;
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  border: 1px solid rgba(21, 63, 117, 0.12);
  box-shadow: 0 4px 16px rgba(21, 63, 117, 0.1);
  transition: transform 0.25s ease, box-shadow 0.25s ease;
  overflow: hidden;
}
.home-section >>> .home-module-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 12px 28px rgba(21, 63, 117, 0.18),
    0 0 0 2px rgba(155, 192, 74, 0.4);
}
.home-view--dark .home-section >>> .home-module-card {
  border-color: rgba(66, 113, 171, 0.3);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}
.home-view--dark .home-section >>> .home-module-card:hover {
  box-shadow: 0 12px 32px rgba(21, 63, 117, 0.25),
    0 0 0 2px rgba(186, 211, 92, 0.35);
}

.home-section >>> .home-module-card .widget-user-header {
  position: relative;
  min-height: 150px;
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
  padding: 1.25rem 1rem;
  border-radius: 12px 12px 0 0;
  background: linear-gradient(
    135deg,
    #153f75 0%,
    #1e5a9e 50%,
    #0d2d5c 100%
  ) !important;
  overflow: hidden;
}
.home-section >>> .home-module-card .widget-user-header::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #9bc04a, #bad35c);
  pointer-events: none;
}
.home-view--dark
  .home-section
  >>> .home-module-card
  .widget-user-header::before {
  background: linear-gradient(90deg, #7fb83a, #bad35c, #9bc04a);
  opacity: 1;
}
.home-section >>> .home-module-card .widget-user-header::after {
  content: "";
  position: absolute;
  top: -20%;
  right: -20%;
  width: 60%;
  height: 60%;
  background: radial-gradient(
    circle,
    rgba(255, 255, 255, 0.08) 0%,
    transparent 70%
  );
  pointer-events: none;
}
.home-card-badge {
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.05em;
  opacity: 0.9;
  text-transform: uppercase;
}
.home-section >>> .home-module-card .widget-user-desc {
  font-size: 1.2rem;
  font-weight: 600;
  margin: 0;
  position: relative;
  z-index: 1;
  text-align: right;
  line-height: 1.3;
}

.home-section >>> .home-module-card .card-footer {
  flex: 1 0 auto;
  display: flex;
  align-items: center;
  background: #fff;
  border-top: 2px solid rgba(21, 63, 117, 0.12);
}
.home-view--dark .home-section >>> .home-module-card .card-footer {
  background: #0f1830;
  border-top-color: rgba(66, 113, 171, 0.25);
}

/* Botón Acceder: blanco y azul, buen contraste */
.home-section >>> .home-btn-vermas {
  border: 2px solid #153f75;
  color: #153f75;
  background: #fff;
  font-weight: 600;
  padding: 0.65rem 1rem;
  border-radius: 8px;
  transition: all 0.25s ease;
  font-size: 0.95rem;
}
.home-section >>> .home-btn-vermas:hover {
  background: #153f75;
  color: #fff;
  border-color: #153f75;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(21, 63, 117, 0.3);
}
.home-section >>> .home-btn-vermas i {
  transition: transform 0.2s ease;
}
.home-section >>> .home-btn-vermas:hover i {
  transform: translateX(3px);
}
.home-view--dark .home-section >>> .home-btn-vermas {
  border-color: #3b82c4;
  color: #93c5fd;
  background: rgba(15, 24, 48, 0.6);
}
.home-view--dark .home-section >>> .home-btn-vermas:hover {
  background: #153f75;
  color: #fff;
  border-color: #153f75;
  box-shadow: 0 4px 12px rgba(21, 63, 117, 0.4);
}

/* Botón Cambiar cliente */
.home-btn-back {
  border: 1px solid rgba(255, 255, 255, 0.5);
  color: rgba(255, 255, 255, 0.9);
  background: transparent;
  border-radius: 6px;
  padding: 0.4rem 0.75rem;
  transition: all 0.2s ease;
}
.home-btn-back:hover {
  background: rgba(255, 255, 255, 0.15);
  color: #fff;
  border-color: #fff;
}
</style>

<!-- <style>
.center-block {
  display: flex;
  align-items: center;
  justify-content: center;
}

.wrapper {
  width: 100%;
  height: 80vh;
  margin-left: 0 !important;
}

.content-wrapper,
.content,
.container-fluid {
  height: 100%;
  margin-left: 0 !important;
  width: 100% !important;
  max-width: 100% !important;
}

.welcome-box {
  position: relative;
  border-radius: 12px;
  min-height: calc(118vh - 200px);
  padding: 40px 20px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  color: #000;
  overflow: hidden;
}

.welcome-box::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url("../../public/img/fondos/malla-IT.png") no-repeat center top;
  background-size: cover;
  opacity: 0.2;
  z-index: 0;
}

.welcome-box h2,
.welcome-box p {
  background: rgba(255, 255, 255, 0.5);
  padding: 5px 10px;
  border-radius: 8px;
  position: relative;
  z-index: 1;
}
</style> -->
